import Icon from '../../../components/AppIcon';
import { WorkflowStep } from '../types';

const HowItWorksSection = () => {
  const steps: WorkflowStep[] = [
    {
      id: "1",
      title: "Discovery Call",
      description: "We analyze your current processes, identify automation opportunities, and calculate potential time savings.",
      icon: "Search"
    },
    {
      id: "2",
      title: "Custom Strategy",
      description: "Our team designs a tailored automation roadmap aligned with your business goals and technical requirements.",
      icon: "FileText"
    },
    {
      id: "3",
      title: "Implementation",
      description: "We build, test, and deploy your automation systems with minimal disruption to your operations.",
      icon: "Settings"
    },
    {
      id: "4",
      title: "Optimization",
      description: "Continuous monitoring, refinement, and scaling to ensure maximum efficiency and ROI.",
      icon: "TrendingUp"
    }
  ];

  return (
    <section className="bg-background py-16 lg:py-24">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 space-y-4">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full">
            <Icon name="Lightbulb" size={16} className="text-primary" />
            <span className="text-sm font-medium text-primary">Our Process</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary">
            From Consultation to Automation in 4 Steps
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Our proven methodology ensures smooth implementation and measurable results.
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={step.id} className="relative">
                <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300 hover:border-primary h-full">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name={step.icon} size={24} className="text-primary" />
                    </div>
                    <div className="text-4xl font-bold text-primary/20">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                  </div>

                  <h3 className="text-lg font-semibold text-text-primary mb-3">
                    {step.title}
                  </h3>

                  <p className="text-sm text-text-secondary leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <Icon name="ArrowRight" size={24} className="text-primary/30" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;